// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import Icon from '../_common/form/Icon';
import { useGlobalState } from '../_common/globalState/GlobalStateProvider';

const Card = styled.div`
    display: flex;    
    flex-direction: column;
    font-size: 0.95em;
    padding: ${({ collapsed }) => collapsed ? '0.2em 0.5em' : '0.5em'};
    margin-bottom: 0.2rem;
    background-color: ${({ theme }) => theme.mobile.body};
    border-radius: 0.5rem;
    border: 2px solid ${({ theme }) => theme.mobile.tertiary};    
    transition: all 0.2s;
    ${({ height, collapsed }) => collapsed ? `height: 2em;` : height && `height: ${height}px;`};
`
const Overflow = styled.div`
    overflow: hidden;
`
const HeightWrapper = styled.div`
    display: flex;
    flex-direction: column;
`
const Row = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all 0.2s;
    height: 2em;
    //height: ${({ collapsed }) => collapsed ? `2em` : `3em`};
`
const I = styled(Icon)`
    transform: rotate(${({ collapsed }) => collapsed ? '90deg' : '0deg'});
    transition: all 0.3s;
`
const Title = styled.div`
    font-weight: normal;
    white-space: pre-line;
`

const CardInset = ({ smooth, children, ...props }) => {
    const {
        state: {
            OS
        },
    } = useGlobalState();

    const [cardHeight, setCardHeight] = useState(null)
    const [collapsed, setCollapsed] = useState(props.collapsible)
    const cardRef = useRef(null);

    const observer = useRef(
        new ResizeObserver(entries => {
            const { height } = entries[0].contentRect
            setCardHeight(height)
            //setCardHeight(cardRef.current?.getBoundingClientRect().height)
        })
    )

    useEffect(() => {
        const element = observer.current;
        const ref = cardRef.current;

        if (element) {
            element.observe(ref)
        }

        return () => element.unobserve(ref)
    }, [cardRef, observer])

    const handleClick = (e, body) => {
        if (!props.collapsible) return;
        setCollapsed(!collapsed);
    }

    return (
        <Card height={cardHeight} collapsed={collapsed} noSlide={props.noSlide} className={props.className} os={OS}>
            <Overflow>
                <HeightWrapper ref={cardRef}  {...props}>
                    {
                        props.collapsible ?
                            <Row collapsed={collapsed} onClick={handleClick}>
                                <Title icon={props.icon}>{props.title}</Title>
                                <I icon='chevronDown' collapsed={collapsed ? 1 : 0} />
                            </Row> :
                            props.title ?
                                <Title icon={props.icon}>{props.title}</Title> : null
                    }
                    {children}
                </HeightWrapper>
            </Overflow>
        </Card>
    );
}

export default CardInset;